import { render } from "./UiDepartaments.vue?vue&type=template&id=59c3a7da"
import script from "./UiDepartaments.vue?vue&type=script&lang=js"
export * from "./UiDepartaments.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/studyflow-frontend/studyflow-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__